import request from './request.js'

// 轮播图数据(无需传参)
export function getSlideListData(query) {
  return request({
    url: '/officialWebsite/honeIndex/getSlideListData',
    method: 'get',
    params: query
  })
}

// 首页数据(无需传参)
export function getHomePageData(query) {
  return request({
    url: '/officialWebsite/honeIndex/getHomePageData',
    method: 'get',
    params: query
  })
}

// 导航栏数据(无需传参)
export function getNavigationBarData(query) {
  return request({
    url: '/officialWebsite/honeIndex/getNavigationBarData',
    method: 'get',
    params: query
  })
}

// 产品详情数据(传参:id)
export function getProductData(query) {
  return request({
    url: '/officialWebsite/honeIndex/getProductData',
    method: 'get',
    params: query
  })
}

// 文章列表数据(可选择传参:type 0新闻 1活动)
export function getNewsEventsListData(query) {
  return request({
    url: '/officialWebsite/honeIndex/getNewsEventsListData',
    method: 'get',
    params: query
  })
}

// 文章详情数据(传参:id)
export function getNewsEventsData(query) {
  return request({
    url: '/officialWebsite/honeIndex/getNewsEventsData',
    method: 'get',
    params: query
  })
}
// 技术专栏列表数据(无需传参)
export function getWebTechFeaturesListData(query) {
  return request({
    url: '/officialWebsite/honeIndex/getWebTechFeaturesListData',
    method: 'get',
    params: query
  })
}

// 技术专栏详情数据(传参:id)
export function getWebTechFeaturesData(query) {
  return request({
    url: '/officialWebsite/honeIndex/getWebTechFeaturesData',
    method: 'get',
    params: query
  })
}

//根据参数键名查询参数值
export function getConfigKey(configKey) {
  return request({
    url: '/system/config/configKey/' + configKey,
    method: 'get'
  })
}
// 获取列表主键id
export function getListIds(query) {
  return request({
    url: '/officialWebsite/honeIndex/getListIds',
    method: 'get',
    params: query
  })
}
